<p *ngIf="!!printableIngredients" class="ingredient-description-list">
  <ng-container *ngFor="let printableIngredient of printableIngredients; let last = last; trackBy: identify">
    <span
      tabindex="0"
      style="display: block"
      [ngClass]="{'line-through' : printableIngredient.isDefault && !printableIngredient.isSelected,
      'fw-500' : !printableIngredient.isDefault && printableIngredient.isSelected}"
      class="p-0 m-0 no-border text-left primary-text-color"
    >
    {{printableIngredient.printText}}</span>
    <span *ngIf="!last" aria-hidden="true">,&nbsp;</span>
  </ng-container>
</p>
